/* eslint-disable @typescript-eslint/no-explicit-any */
import { Profile } from '../../components/font-end/Profile/Profile';
import { NewsHighlight } from '../../components/font-end/HomeNews/NewsHighlight';
import { TimeInOut } from '../../components/font-end/TimeInfo/TimeInOut';
import { PayrollCutoff } from '../../components/font-end/PayrollCalendar/PayrollCutoff';
import { PayrollCutoffLastDowload } from '../../components/font-end/PayrollCalendar/PayrollCutoffLastDowload';
import { Menubar } from '../../components/font-end/MasterLayout/Menubar';
import { useUser } from '../../context/UserContext';

export const Home = () => {
  const { userInfo, isLoading } = useUser();
  const getData = JSON.parse(sessionStorage.getItem('obj_user_info') || '{}');

  if (isLoading || !userInfo) {
    return <div className="layout-loading">
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>;
  }

  return (
    <>
      <Profile />
      <NewsHighlight />
      <TimeInOut renderBxo="none"/>
      <PayrollCutoff />
      <PayrollCutoffLastDowload />
      <Menubar />
    </>
  );
};
